import Info from '@/components/ezuro/workschedule/components/edit/Info.vue';
import Events from '@/components/ezuro/workschedule/components/edit/Events.vue';

export default {
  name: 'RecordEdit',
  data () {
    return {
      elData: {},
      isLoading: false,
      activeTab: 'Info',
      somethingChanged: false,
      allowMultiDepartmentSelect: false
    }
  },
  components: {
    Info,
    Events
  },
  props: {
    editPerm: {
      type: String,
      default: 'edit-records'
    },
    basePath: {
      type: String,
      default: 'ezuro/schedule/row'
    },
    isModal: {
      type: Boolean,
      default: true
    },
    filterData: {
      type: Object
    },
    scheduleData: {
      type: Object
    }
  },
  computed: {
    baseTransParam () {
      return 'work-schedule';
    },
    getTitle () {
      if (this.elData.id) {
        return this.$t(`${this.baseTransParam}.edit-schedule-row`) + ' - ' + this.$t('work-schedule.type-options.' + this.elData.type);
      }
      return this.$t(`${this.baseTransParam}.add-schedule-row`) + ' - ' + (this.elData.type ? this.$t('work-schedule.type-options.' + this.elData.type) : '');
    },
    tabOptions () {
      const tabs = [{ code: 'Info', text: this.$t('work-schedule.info'), slotcode: 'Info' }];

      if (this.elData.id) {
        tabs.push({ code: 'Events', text: this.$t('work-schedule.events'), slotcode: 'Events' });
      }

      return tabs;
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  methods: {
    setLoading (value) {
      this.isLoading = value;
    },
    show (data) {
      this.allowMultiDepartmentSelect = data.allowMultiDepartmentSelect;
      this.elData = data.record;
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    },
    remove () {
      this.isLoading = true;
      this.ApiRequest.request(this.basePath + '/destroy/' + this.elData.id, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.changed();
          this.close();
        }
        this.isLoading = false;
      });
    },
    save (reqData) {
      this.isLoading = true;
      const action = reqData.only_comment ? '/save-comment' : '/save';
      this.ApiRequest.request(this.basePath + action + (reqData.id ? '/' + reqData.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.changed();
          this.close();
        }
        this.isLoading = false;
      });
    },
    loadEvents () {
      const path = `ezuro/schedule/row/events/${this.elData.id}`;
      this.isLoading = true;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          this.elData.events = response.data;
          this.isLoading = false;
          this.changed();
        }
      });
    },
    changed () {
      this.$emit('changed');
    },
    modalClosed () {
      this.$emit('hidden', true);
    }
  }
}
